import { MetricLimitsPage } from "./MetricLimitsPage";
import {
  ROOF_PARENT_PART_TYPE_IDS,
  SIDEWALL_PARENT_PART_TYPE_IDS,
  CASTER_PARENT_PART_TYPE_IDS,
} from "./models/metricLimits.constants";
import { Route, Routes } from "react-router-dom";

export const CatalogRoofMetricLimits = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <MetricLimitsPage
            title="EAF Roof Metric Limits"
            parentPartTypeIds={ROOF_PARENT_PART_TYPE_IDS}
          />
        }
      />
    </Routes>
  );
};

export const CatalogSidewallMetricLimits = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <MetricLimitsPage
            title="EAF Sidewall Metric Limits"
            parentPartTypeIds={SIDEWALL_PARENT_PART_TYPE_IDS}
          />
        }
      />
    </Routes>
  );
};

export const CatalogCasterMetricLimits = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <MetricLimitsPage
            title="Caster Mold Metric Limits"
            parentPartTypeIds={CASTER_PARENT_PART_TYPE_IDS}
          />
        }
      />
    </Routes>
  );
};
